/**
 * Link that works both inside a tab (react-router Link) and on the zero-tab Home
 * (no tab router: open a tab instead). Zero-tab = no hand-off, so onBeforeNavigate is skipped.
 */
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ShellContext } from '../shellContext';
import { useTab } from '../TabContext';

interface Props {
  to: string;
  replace?: boolean | undefined;
  onBeforeNavigate?: (() => void) | undefined;
  className?: string | undefined;
  'data-testid'?: string | undefined;
  children: React.ReactNode;
}

export const ShellNavLink: React.FC<Props> = ({ to, replace, onBeforeNavigate, className, children, ...rest }) => {
  const shell = useContext(ShellContext);
  const { tabId } = useTab();
  const testId = rest['data-testid'];
  if (tabId === '') {
    return (
      <a
        href={to}
        data-testid={testId}
        className={className}
        onClick={(e) => { e.preventDefault(); shell?.openTab(to); }}
      >
        {children}
      </a>
    );
  }
  return (
    <Link to={to} replace={replace ?? false} data-testid={testId} className={className} onClick={onBeforeNavigate}>
      {children}
    </Link>
  );
};

export default ShellNavLink;
